@if (isLoggedIn) {
  <a [matMenuTriggerFor]="menu">
    <img src="/assets/images/user.png" />
    <span>My Account</span>
  </a>

  <mat-menu #menu="matMenu">
    <div class="user-info">
      <div class="user-name">{{ userName }}</div>
      <div class="user-email">{{ userEmail }}</div>
    </div>
    <button mat-menu-item (click)="logout()">
      <mat-icon>exit_to_app</mat-icon>
      <span>Sign Out</span>
    </button>
  </mat-menu>
}
